import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Cancel, InfoOutlined, ThumbDownAlt, ThumbUp, Update } from "@material-ui/icons";
// import { useHasAccess, useTtmsAuth } from '@@airborne/react-admin'
import { useAuth } from "@airborne/react-admin";
import React, { useEffect, useState } from "react";
import {
  Button,
  NumberInput,
  SelectInput,
  TextInput,
  Toolbar,
  maxValue,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { UnserviceableStatu } from "../../../../../Enums/UnserviceableStatus";
import { useAppDataProvider } from "../../../../../dataprovider";
import { PbhRequestUnserviceablePutModel } from "../../../../../Pages/RequestOrder/Models/PbhRequestUnserviceableModel";
import { PbhRequestFileType } from "../../../../../Enums/PbhRequestFileType";
import { GetPbhRemoveReasonType, PbhRemoveReasonType } from "../../../../../Enums/PbhRemoveReasonType";
import { GetPbhRemoveReasonSubType, UnscheduledRemoveReasonSubType } from "../../../../../Enums/RemoveReasonSubType";
import { SectionTitle } from "../../../../../Components/SectionTitle";
import PbhUnserviceableStatusChip from "../../Statu/PbhUnserviceableStatusChip";
import { Separator } from "../../../../../Components/Separator";
import { CustomDatetime } from "../../../../../Components/CustomDatetime";
import { PbhUnserviceableReplenishmentType } from "../../../../../Constants/Constant";
import { GetPbhCarrierType } from "../../../../../Enums/PbhCarrierType";
import { PbhRequestStatus } from "../../../../../Enums/PbhRequestStatus";
import { ExperienceNoteType } from "../../../../../Enums/ExperienceNoteType";
import ExperienceSoftWarningDialog from "../../ExperiencePopup";
import { Roles } from "../../../../../Enums/Roles";
import { HourMinuteInput } from "../../../../../Components/HourMinuteInput";

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const UnserviceableUpdate = props => {
  const [loading, setLoading] = useState(false);
  const [unserviceableFormDisabled, setUnserviceableFromDisabled] = useState(true);
  const [approveButtonShown, setApproveButtonShown] = useState(false);
  const [isEightWing, setIsEightWing] = useState<boolean>(false);
  const [isButtonShow, setIsButtonShow] = useState(
    props.unserviceable?.status == UnserviceableStatu.Accepted ||
      props.unserviceable?.status == UnserviceableStatu.Rejected
  );
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const requestId = props.requestId;
  const requestDetail = props?.requestDetail;

  const classes = useStyles();

  useEffect(() => {
    setIsButtonShow(
      props.unserviceable?.status == UnserviceableStatu.Accepted ||
        props.unserviceable?.status == UnserviceableStatu.Rejected
    );
  }, [props.unserviceable]);

  // useEffect(() => {
  //   setIsEightWing(user?.roles?.some?.(x => x == Roles.EightWings) ?? false);
  // }, [user]);

  const UpdateUnserviceableButtonClick = (e, form) => {
    UpdateUnserviceable(e);
  };
  const UpdateUnserviceable = e => {
    setLoading(true);
    let pbhRequestUnserviceableUpdateModel: PbhRequestUnserviceablePutModel = new PbhRequestUnserviceablePutModel();
    pbhRequestUnserviceableUpdateModel.Id = props.unserviceable.id;
    pbhRequestUnserviceableUpdateModel.RequestId = props.unserviceable.requestId;
    pbhRequestUnserviceableUpdateModel.Pn = e.pn;
    pbhRequestUnserviceableUpdateModel.Sn = e.sn;
    pbhRequestUnserviceableUpdateModel.Awb = e.awb;
    pbhRequestUnserviceableUpdateModel.CarrierEnum = e.carrierEnum ?? 0;
    pbhRequestUnserviceableUpdateModel.FlightNo = e.flightNo;
    pbhRequestUnserviceableUpdateModel.ForwardDateToCarrier = e.forwardDateToCarrier;
    pbhRequestUnserviceableUpdateModel.EstimatedDeliveryDate = e.estimatedDeliveryDate;
    pbhRequestUnserviceableUpdateModel.Ac = e.ac;
    pbhRequestUnserviceableUpdateModel.Batch = e.batch;
    pbhRequestUnserviceableUpdateModel.RemoveReasonType = e.removeReasonType;
    pbhRequestUnserviceableUpdateModel.RemoveReasonSubType = e.removeReasonSubType;
    pbhRequestUnserviceableUpdateModel.RemoveDateFromAc = e.removeDateFromAc;
    pbhRequestUnserviceableUpdateModel.Tso = e.tso;
    pbhRequestUnserviceableUpdateModel.Cso = e.cso;
    pbhRequestUnserviceableUpdateModel.Dso = e.dso;
    pbhRequestUnserviceableUpdateModel.Tsr = e.tsr;
    pbhRequestUnserviceableUpdateModel.Csr = e.csr;
    pbhRequestUnserviceableUpdateModel.Dsr = e.dsr;
    pbhRequestUnserviceableUpdateModel.Tsn = e.tsn;
    pbhRequestUnserviceableUpdateModel.Csn = e.csn;
    pbhRequestUnserviceableUpdateModel.Dsn = e.dsn;
    pbhRequestUnserviceableUpdateModel.Tsi = e.tsi;
    pbhRequestUnserviceableUpdateModel.Csi = e.csi;
    pbhRequestUnserviceableUpdateModel.Dsi = e.dsi;
    pbhRequestUnserviceableUpdateModel.Status = props.unserviceable.status;
    pbhRequestUnserviceableUpdateModel.Remark = e.remark;
    pbhRequestUnserviceableUpdateModel.RemovalReasonDetail = e.removalReasonDetail;
    pbhRequestUnserviceableUpdateModel.AdSbMod = e.adSbMod;
    pbhRequestUnserviceableUpdateModel.Dom = e.dom;
    pbhRequestUnserviceableUpdateModel.Nla = e.nla;
    pbhRequestUnserviceableUpdateModel.Nha = e.nha;
    pbhRequestUnserviceableUpdateModel.EngineSerialNumber = e.engineSerialNumber;
    pbhRequestUnserviceableUpdateModel.RejectionRemark = e.rejectionRemark;

    PutUnserviceable(pbhRequestUnserviceableUpdateModel);
  };

  const PutUnserviceable = async (pbhRequestUnserviceablePutModel: PbhRequestUnserviceablePutModel) => {
    dataProvider
      .putPbhRequestUnserviceable(pbhRequestUnserviceablePutModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        history.push("/eightwings/" + props.eightWingsId + "/2");
        setIsButtonShow(true);
        setApproveButtonShown(false);
        setUnserviceableFromDisabled(true);
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const AcceptOrRejectButtonClick = (unserviceable, isApproved) => e => {
    AcceptOrRejectUnserviceable(unserviceable, isApproved);
  };

  const AcceptOrRejectUnserviceable = async (unserviceable, isApproved) => {
    let pbhRequestUnserviceableUpdateModel: PbhRequestUnserviceablePutModel;

    pbhRequestUnserviceableUpdateModel = { ...unserviceable };
    pbhRequestUnserviceableUpdateModel.Status =
      isApproved === true ? UnserviceableStatu.Accepted : UnserviceableStatu.Rejected;

    dataProvider
      .putPbhRequestUnserviceable(pbhRequestUnserviceableUpdateModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        setIsButtonShow(true);
        history.push("/eightwings/" + props.eightWingsId + "/2");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const openEditableFields = e => {
    setApproveButtonShown(true);
    setUnserviceableFromDisabled(false);
  };

  const cancelUpdate = e => {
    setApproveButtonShown(false);
    setUnserviceableFromDisabled(true);
  };

  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };

  const IsUpdate = values => {
    let isUnUsedStatement =
      props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.UnusedStatement
      )?.length === 0
        ? false
        : true;

    if (values.removeReasonType === PbhRemoveReasonType.ServiceableReturn) {
      if (!isUnUsedStatement) {
        return false;
      }
    }

    let isUsTagExist =
      props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.UsTag
      )?.length === 0
        ? false
        : true;

    //Reliability US TAG file check if FoF
    if (
      values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit
    ) {
      if (!isUsTagExist) {
        return false;
      }
      if (values.tsi !== 0) {
        return false;
      }
    }

    //Reliability US TAG file check if Premature Failure
    if (
      values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure
    ) {
      if (!isUsTagExist) {
        return false;
      }
      if (values.tsi === 0 || values.tsi > 30000) {
        return false;
      }
    }

    return true;
  };

  const removeReasonChangeEvent = form => e => {
    form.change("removeReasonSubType", null);
    if (e.target.value === PbhRemoveReasonType.ServiceableReturn) {
      form.change("tsi", 0);
      form.change("csi", 0);
      form.change("removeDateFromAc", moment.utc().local());
    }
  };

  const markFormTouched = (form, values) => {
    values.carrierEnum = values.carrierEnum > 0 ? values.carrierEnum : null;
    form.initialize(values);
    // koşullu from validations çalışmıyor, onları tetiklemek için yapıldı
    form.batch(() => {
      Object.keys(values || {}).forEach(field => {
        form.registerField(field, () => {}, { touched: true });
      });
    });
  };

  return (
    <>
      <Form
        initialValues={props.unserviceable}
        onSubmit={UpdateUnserviceableButtonClick}
        render={({ handleSubmit, form, values }) => {
          // useEffect(() => {
          //   markFormTouched(form, values);
          // }, [isEightWing]);
          return (
            <form>
              <>
                <Grid container justifyContent="space-around" spacing={2}>
                  <Grid item xs={12} container justifyContent="space-around">
                    <SectionTitle label="Core Unit Info" />
                    <PbhUnserviceableStatusChip unserviceable={props.unserviceable} />
                  </Grid>
                  <Separator />
                  <Grid item xs={12} container justifyContent="space-around">
                    <Grid item xs={6} container direction="column" alignItems="center">
                      <Grid item xs={10}>
                        <TextInput
                          source="pn"
                          label="PN"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                          defaultValue={requestDetail?.pn}
                          disabled={unserviceableFormDisabled}
                        />
                        <TextInput
                          source="sn"
                          label="SN"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                          disabled={unserviceableFormDisabled}
                        />
                        <TextInput
                          source="ac"
                          label="AC"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                          defaultValue={requestDetail?.aircraft?.acReg}
                          disabled={unserviceableFormDisabled}
                        />
                        <NumberInput
                          source="batch"
                          label="Batch"
                          fullWidth
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                        />
                        <CustomDatetime
                          fullWidth
                          source="removeDateFromAc"
                          label="Remove Date from AC"
                          variant="outlined"
                          showTime
                          maxDate={values.forwardDateToCarrier}
                          validate={[
                            required(),
                            maxValue(values.forwardDateToCarrier, "Should be before than Forward Date To Carrier"),
                          ]}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                          disabled={unserviceableFormDisabled}
                        />

                        <Grid container spacing={1}>
                          <Grid item xs>
                            <HourMinuteInput
                              source="tso"
                              label="TSO (Hour)"
                              hourDigits={7}
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="cso"
                              label="CSO (Cycle)"
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="dso"
                              label="DSO (Days)"
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs>
                            <HourMinuteInput
                              source="tsr"
                              label="TSR (Hour)"
                              hourDigits={7}
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="csr"
                              label="CSR (Cycle)"
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="dsr"
                              label="DSR (Days)"
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs>
                            <HourMinuteInput
                              source="tsn"
                              label="TSN (Hour)"
                              hourDigits={7}
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="csn"
                              label="CSN (Cycle)"
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="dsn"
                              label="DSN (Days)"
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <Grid item container spacing={1}>
                          {values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                            values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit &&
                            values.tsi !== 0 && (
                              <Chip
                                key={9999990}
                                color="primary"
                                variant="outlined"
                                label="Removal reason was selected as Unscheduled - Fail On Fit, TSI hour input must be 0."
                                icon={<InfoOutlined />}
                              />
                            )}
                        </Grid>
                        <Grid item container spacing={1}>
                          {values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                            values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure &&
                            (values.tsi === 0 || values.tsi > 30000) && (
                              <Chip
                                key={9999990}
                                color="primary"
                                variant="outlined"
                                label="Removal reason was selected as Unscheduled - Premature, TSI hour cannot be 0 and must be less than 500 FH."
                                icon={<InfoOutlined />}
                              />
                            )}
                        </Grid>
                        <Grid item container spacing={1}>
                          <Grid item xs>
                            <HourMinuteInput
                              source="tsi"
                              label="TSI (Hour)"
                              hourDigits={7}
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="csi"
                              label="CSI (Cycle)"
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                          <Grid item xs>
                            <NumberInput
                              source="dsi"
                              label="DSI (Days)"
                              fullWidth
                              variant="outlined"
                              disabled={unserviceableFormDisabled}
                            />
                          </Grid>
                        </Grid>
                        <TextInput
                          source="dom"
                          label="DOM"
                          fullWidth
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                        />
                        <TextInput
                          source="nha"
                          label="NHA"
                          fullWidth
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                        />
                        <SelectInput
                          source="replenishmentReason"
                          label="REPLENISHMENT REASON"
                          optionText="replenishmentTypes"
                          optionValue="value"
                          choices={PbhUnserviceableReplenishmentType}
                          fullWidth
                          resettable
                          disabled
                          defaultValue={requestDetail?.aircraft?.acReg}
                          variant="outlined"
                        />
                        <TextInput
                          source="rejectionRemark"
                          label="REJECTION REMARK"
                          fullWidth
                          resettable
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                          validate={
                            values.removeReasonType === PbhRemoveReasonType.RejectedQuarantinedPart
                              ? required()
                              : undefined
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={6} container direction="column" alignItems="center">
                      <Grid item xs={10}>
                        <TextInput
                          source="awb"
                          label="AWB"
                          fullWidth
                          variant="outlined"
                          validate={isEightWing ? required() : undefined}
                          disabled={unserviceableFormDisabled}
                        />
                        <TextInput
                          source="flightNo"
                          label="Flight No"
                          fullWidth
                          variant="outlined"
                          validate={isEightWing ? required() : undefined}
                          disabled={unserviceableFormDisabled}
                        />
                        <SelectInput
                          source="carrierEnum"
                          label="Carrier Type"
                          choices={GetPbhCarrierType}
                          optionText="Description"
                          optionValue="Value"
                          fullWidth
                          variant="outlined"
                          validate={isEightWing ? required() : undefined}
                          disabled={unserviceableFormDisabled}
                        />
                        <CustomDatetime
                          fullWidth
                          source="forwardDateToCarrier"
                          label="Forward Date To Carrier"
                          variant="outlined"
                          showTime
                          minDate={values.removeDateFromAc}
                          maxDate={values.estimatedDeliveryDate}
                          validate={
                            isEightWing
                              ? [
                                  required(),
                                  minValue(values.removeDateFromAc, "Should be later than Remove Date from Ac"),
                                  maxValue(values.estimatedDeliveryDate, "Should be before Forward Date to Carrier"),
                                ]
                              : [
                                  minValue(values.removeDateFromAc, "Should be later than Remove Date from Ac"),
                                  maxValue(values.estimatedDeliveryDate, "Should be before Forward Date to Carrier"),
                                ]
                          }
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                          disabled={unserviceableFormDisabled}
                        />
                        <CustomDatetime
                          fullWidth
                          source="estimatedDeliveryDate"
                          label="Estimated Delivery Date"
                          variant="outlined"
                          showTime
                          minDate={values.forwardDateToCarrier}
                          validate={
                            isEightWing
                              ? [
                                  required(),
                                  minValue(values.forwardDateToCarrier, "Should be later than Forward Date to Carrier"),
                                ]
                              : [minValue(values.forwardDateToCarrier, "Should be later than Forward Date to Carrier")]
                          }
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                          disabled={unserviceableFormDisabled}
                        />
                        <SelectInput
                          source="removeReasonType"
                          label="Remove Reason Type"
                          choices={GetPbhRemoveReasonType}
                          optionText="Description"
                          optionValue="Value"
                          fullWidth
                          variant="outlined"
                          onChange={removeReasonChangeEvent(form)}
                          validate={required()}
                          disabled={unserviceableFormDisabled}
                        />
                        {GetPbhRemoveReasonSubType(values.removeReasonType) && (
                          <SelectInput
                            source="removeReasonSubType"
                            label="Remove Reason Sub Type"
                            choices={GetPbhRemoveReasonSubType(values.removeReasonType)}
                            optionText="Description"
                            optionValue="Value"
                            fullWidth
                            variant="outlined"
                            validate={required()}
                            disabled={unserviceableFormDisabled}
                          />
                        )}
                        {values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                          (values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit ||
                            values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure) && (
                            <Chip
                              key={9999990}
                              color="primary"
                              variant="outlined"
                              label={
                                values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit
                                  ? "Please Upload US TAG for Unserviceable Fail On Fit Requests!"
                                  : "Please Upload US TAG for Unserviceable Premature Failure Requests!"
                              }
                              icon={<InfoOutlined />}
                            />
                          )}
                        <TextInput
                          source="remark"
                          label="Remarks of Customer"
                          multiline
                          resettable
                          fullWidth
                          rows={4}
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                        />
                        <TextInput
                          source="removalReasonDetail"
                          label="Removal Reason Detail"
                          fullWidth
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                        />
                        <TextInput
                          source="nla"
                          label="NLA"
                          fullWidth
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                        />
                        <TextInput
                          source="adSbMod"
                          label="AD(SB/MOD)"
                          fullWidth
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                        />
                        <TextInput
                          source="engineSerialNumber"
                          label="Engine Serial Number"
                          fullWidth
                          resettable
                          variant="outlined"
                          disabled={unserviceableFormDisabled}
                          defaultValue={props.unserviceable?.engineSerialNumber}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Toolbar {...props} placeholder="" classes={classes}>
                      {approveButtonShown === false &&
                        ((user?.isCustomer && props?.requestDetail?.requestStatus !== PbhRequestStatus.Accomplished) ||
                          !user?.isCustomer) && (
                          <>
                            <Button
                              label="Edit Core Unit"
                              disabled={loading || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled}
                              size="medium"
                              variant="contained"
                              onClick={openEditableFields}
                              style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "#ffc107" }}
                            >
                              {<Update />}
                            </Button>

                            {!user?.isCustomer && (
                              <>
                                <Button
                                  label={loading ? "Core Unit is Accepted!" : "Accept Core Unit"}
                                  disabled={
                                    isButtonShow || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled
                                  }
                                  size="medium"
                                  variant="contained"
                                  onClick={AcceptOrRejectButtonClick(props.unserviceable, true)}
                                  style={isButtonShow ? { margin: "8px" } : { margin: "8px", background: "seagreen" }}
                                >
                                  {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbUp />}
                                </Button>
                                <Button
                                  label={loading ? "Core Unit is Rejected!" : "Reject Core Unit"}
                                  disabled={
                                    isButtonShow || props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled
                                  }
                                  size="medium"
                                  variant="contained"
                                  color="primary"
                                  onClick={AcceptOrRejectButtonClick(props.unserviceable, false)}
                                  style={{ margin: "8px" }}
                                >
                                  {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDownAlt />}
                                </Button>
                              </>
                            )}
                          </>
                        )}

                      {approveButtonShown === true && (
                        <>
                          <Button
                            label={loading ? "Core Unit is updating!" : "Update Core Unit"}
                            disabled={loading ? true : !IsUpdate(values)}
                            size="medium"
                            variant="contained"
                            onClick={handleSubmit}
                            style={{
                              margin: "8px",
                              background: "#ffc107 !important",
                            }}
                          >
                            {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                          </Button>
                          <Button
                            label={loading ? "Cancel!" : "Cancel "}
                            disabled={loading}
                            size="medium"
                            variant="contained"
                            color="primary"
                            onClick={cancelUpdate}
                            style={{ margin: "8px" }}
                          >
                            {<Cancel />}
                          </Button>
                        </>
                      )}
                    </Toolbar>
                  </Grid>
                </Grid>
              </>
            </form>
          );
        }}
      />
      <ExperienceSoftWarningDialog
        data={props?.requestDetail?.experienceData}
        type={ExperienceNoteType.Unserviceable}
      />
    </>
  );
};

const EightWingsUnserviceableUpdate = props => {
  return (
    <UnserviceableUpdate
      unserviceable={props.unserviceable}
      eightWingsId={props?.eightWingsId}
      requestDetail={props.requestDetail}
      requestId={props.requestId}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default EightWingsUnserviceableUpdate;
